module.exports = __webpack_public_path__ + "img/visitorsPage_bg.741abadf.png";